import React from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img1 from "../../../images/locationgcc/qa/androidapp.webp";
import Img2 from "../../../images/locationgcc/qa/iosapp.webp";
import Img3 from "../../../images/locationgcc/qa/hybridapp.webp";
import { Link } from "gatsby";

const Ditigalgcc = () => {
  return (
    <div className="tekrevol_gray_bg acc_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>
              Experience Our Next-Gen Mobile App Development Services in Qatar
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Considering the rapid growth of mobile apps, it has become
              important for every business to have an app solution for operating
              business online. As per the stats, the number of apps available
              for download worldwide has increased by 82% since 2016. So, you
              are losing on multiple opportunities if you haven’t deployed an
              app yet. As a mobile app development company in Qatar, we take
              pride in offering the following services with optimal user
              satisfaction.
            </p>
          </Col>
        </Row>
        <Row>
          <Accordion defaultActiveKey="">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                Native Android App Development
              </Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      The impact of Native Android app development is rapidly
                      growing, and you can reach a broader audience by
                      leveraging this technology. Presently, there has been a
                      31% increase in downloads from the Google Play Store, with
                      a total of 2.87 million live apps available.
                    </p>
                    <p>
                      With our Android app development services in Qatar, you
                      can elevate your business into the digital realm. We have
                      skilled developers specializing in crafting personalized
                      app solutions that leverage the extensive Android
                      ecosystem. Our services are based on strategic planning
                      and custom design with an agile development approach to
                      guarantee high app performance.
                    </p>
                    <p>
                      Our native Android apps stand out in the competitive
                      market by outlining an intuitive user interface. As a
                      result, we empower businesses to foster cultural growth by
                      building robust Android applications.
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      Build an Android App
                    </Link>
                  </div>
                  <div className="acc_img">
                    <LazyLoadImage
                      src={Img1}
                      effect="blur"
                      alt="Image"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Native IOS App Development</Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      The business community is taking note of the swift
                      expansion of iPhone applications. As for now, the Apple
                      Store accommodates a staggering 1.96 million apps.
                      Simultaneously, the cumulative app downloads exceeded 218
                      billion in the previous year, and these numbers continue
                      to rise.
                    </p>
                    <p>
                      By taking advantage of our specialized Native iOS App
                      Development services in Qatar, you can enhance your
                      business’s digital presence. Our master app developers
                      harness the full potential of the iOS ecosystem and excel
                      in tailoring solutions. Employing the latest tech stack in
                      our custom app development approach, we create
                      state-of-the-art app solutions.
                    </p>
                    <p>
                      We ensure that our iOS apps remain at the top in the
                      competitive market by clearly focusing on delivering a
                      seamless user experience. Utilize our advanced development
                      strategy for iPhone apps to seamlessly transition your
                      business into the digital realm.
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      Build an iOS App
                    </Link>
                  </div>
                  <div className="acc_img">
                    <LazyLoadImage
                      src={Img2}
                      effect="blur"
                      alt="Image"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                Cross-Platform App Development
              </Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      Businesses are increasingly favoring cross-platform apps
                      because of their ability to function on multiple
                      platforms. Notably, opting for cross-platform app
                      development can result in cost savings of approximately
                      30-40%.
                    </p>
                    <p>
                      Using our innovative cross-platform app development
                      services in Qatar, you can explore the advantages of
                      cross-platform versatility. Our expert team of app
                      developers creates innovative solutions that seamlessly
                      facilitate different platforms. We prioritize an engaging
                      user experience for different devices with our app
                      solutions.
                    </p>
                    <p>
                      Furthermore, we have managed to enhance the app's
                      efficiency by reducing development time, while resulting
                      in a cost-effective solution. You can have a
                      high-performance experience for users based on our
                      cross-platform apps using robust technologies. Embrace
                      this creative approach to app development to streamline
                      your digital presence.
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      Build an Cross Platform App
                    </Link>
                  </div>
                  <div className="acc_img">
                    <LazyLoadImage
                      src={Img3}
                      effect="blur"
                      alt="Image"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Row>
      </Container>
    </div>
  );
};

export default Ditigalgcc;
